export default __webpack_public_path__ + "static/media/SWT0290.34I-20314_-14781_0.93f17162.jpg";